<template>
    <div>

        <vs-prompt title="Disconect" :class="'footer-hide'" :active.sync="confirmModal" hide-footer>
            <div>
                <h4>Are you sure you want to end the current connection with </h4>
                <h4>a technical support specialist?</h4>
            </div>
            <div class="detail_actions">
                <vs-button class="unimacs_button" @click="confirmModal = false">Continue</vs-button>
                <vs-button class="unimacs_cancel_button mr-3 ml-4" @click="closeModal">Disconnect</vs-button>
            </div>
        </vs-prompt>

        <div v-if="isVisible" class="modal-overlay">
            <div class="modal-content">
                <div class="modal-info">
                    <div class="icon"> <i :class="'icon_ticket'" class="mr-3"></i></div>
                    <div>
                        <p>A technical support specialist has beengranted access to your account. While the access is
                            active,
                            your actions and capabilities in your account are temporarily restricted</p>

                    </div>
                </div>
                <button class="close-btn" @click="confirmModal = true">Disconnect</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            confirmModal: false,
            isVisible: false,
        };
    },
    watch: {
        "$store.state.isSupported"(value) {
            this.blockScreen(value);
        },
    },
    methods: {

        blockScreen(value) {
            this.isVisible = value;
        },

        closeModal() {
            const user = localStorage.user ? JSON.parse(localStorage.user) : null
            const res = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : null;
            if (!user && !res) { return false }
            this.$store.dispatch("disconnectSupport", { id: res.id, company: user.company }).then(() => {
                this.$store.commit("SET_START_SUPPORTING", {
                    support: false,
                    enabled: false
                });
                localStorage.removeItem("user_data");
                this.confirmModal = false;
                window.location.reload()

            })

        },
    },
};
</script>

<style lang="scss">
.modal-overlay {

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    z-index: 900000;
}

.modal-content {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin: 10px;
    width: 400px;
    text-align: right;
}

.modal-info {
    display: flex;
    align-items: center;

    i {
        font-size: 60px;
        border: 1px solid;
        padding: 10px;
        border-radius: 6px;

    }
}

.close-btn {

    background: #ee5544;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 20px;
    // margin-bottom: 20px;
}

.close-btn:hover {
    background: #0056b3;
}

.footer-hide {

    .detail_actions {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    footer {
        display: none !important;

    }
}
</style>